import { Component } from '@angular/core';
import { DataService } from '../../core/services/data/data.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [ RouterLink ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {

  constructor( private DataService : DataService ) {}

  isArabic = false ;

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
    }
    else {
      this.isArabic = false ;
    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }

  ngOnInit(): void { 

    this.changeLang() ;

  }

}
